import { computed, isRef, ref } from 'vue'
import type { MaybeRef } from 'vue'

export default function useConvertTimeToObject(date: MaybeRef<string>) {
  const localDate = isRef(date) ? date : ref<string>(date)

  const localDateArr = computed(() => localDate.value?.split(':'))

  const hours = computed(() => localDateArr.value[0])
  const minutes = computed(() => localDateArr.value[1])
  const seconds = computed(() => localDateArr.value[2])

  return {
    hours,
    minutes,
    seconds,
  }
}
